import React from 'react';
import { useI18n } from '../contexts/I18nContext';
import ErrorBoundary from './ErrorBoundary';

export default function I18nErrorBoundary({ children }) {
  const { t } = useI18n();
  return (
    <ErrorBoundary
      title={t('errorPageTitle')}
      message={t('errorPageMessage')}
      retryLabel={t('retry')}
      homeLabel={t('goHome')}
    >
      {children}
    </ErrorBoundary>
  );
}
